<template>
	<v-app>
		<div @mouseover="showDrawer" @mouseleave="hideDrawer">
			<v-navigation-drawer v-model="drawer" app floating :width="navbar" class="nav-shadow" :class="{'nav--isCollapsed': (navbar === 60)}">
				<v-list>
					<v-list-item class="v-list-item-logo">
						<v-list-item-action class="v-app-logo" style="opacity: .8">
							<img width="100%" :src="require('@/assets/ic-icon.svg')">
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>
								<div class="cl-primary font-size-14 font-weight-bold">
									Virtual Office
									<small class="d-block font-size-8 pt-1 cl-grey">Esoftdream</small>
								</div>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<v-list dense class="pt-0 cus-m-navbar">
					<template v-for="(menu, idm) in arrMenu">
						<div class="cuspad-list-item" v-if="menu.children.length == 0" :key="idm">
							<v-list-item link router :to="`${menu.path}`" color="primary" class="no-drop" @click="setActiveMenu()">
								<v-list-item-action>
									<v-icon>{{ menu.icon }}</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>
										<div class="d-flex align-center justify-space-between">
											{{ menu.title }} 
										</div>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</div>
						<div class="cuspad-list-item" v-else :key="idm">
							<v-list-group 
								:prepend-icon="menu.icon" 
								no-action 
								color="primary" 
								class="v-list-group__items expand-transition-leave-active expand-transition-leave-to"
								:class="(activeMenu === menu.title) ? 'is-activemenu orange lighten-5' : ''">
								<template v-slot:activator>
									<v-list-item-content>
										<v-list-item-title :class="(activeMenu === menu.title) ? 'cl-primary font-weight-bold' : ''">{{ menu.title }}</v-list-item-title>
									</v-list-item-content>
								</template>
								<template v-for="(sub, ids) in menu.children">
									<div class="cuspad-list-item" :key="ids">
										<v-list-item router :to="`${sub.path}`" @click="setActiveMenu(sub.path)" color="primary" class="no-drop" :key="ids">
											<v-list-item-content>
												<v-list-item-title>
													<span v-if="navbar == 60" class="collapse-icon">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
															</template>
															<span class="d-flex align-center justify-space-between">
																{{ sub.title }}
															</span>
														</v-tooltip>
													</span>
													<span v-else>
														<span class="d-flex align-center justify-space-between">
														{{ sub.title }}
														</span>
													</span>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</div>
								</template>
							</v-list-group>
						</div>
					</template>
				</v-list>
			</v-navigation-drawer>
		</div>

		<Header :isDrawer="navbar" v-on:childToParent="clickDrawer" />

		<v-main class="">
			<v-container fluid class="px-3">
				<v-row align="center" justify="center">
					<v-col class="px-0 px-md-3">
						<v-snackbar v-model="snackbar.show" timeout="4000" right top :color="snackbar.color">
							{{snackbar.text}}
							<template v-slot:action="{ attrs }">
								<v-btn color="white" text v-bind="attrs" @click="hideSnackbar">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</template>
						</v-snackbar>
						<v-snackbar v-model="errorAlert.show" timeout="4000" right top :color="errorAlert.color">
							<div v-for="(alert, i) in errorAlert.alert" :key="i">{{ alert }}</div>
							<template v-slot:action="{ attrs }">
								<v-btn color="white" text v-bind="attrs" @click="hideAlert">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</template>
						</v-snackbar>
						<router-view />
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Header from '@/components/layout/vo/Header';

export default {
	components: {
		Header
	},
	props: {
	},
	computed: {
		...mapState(['snackbar', 'errorAlert']),
		...mapState('message', ['listInbox', 'inboxPagination']),
	},
	data: () => ({
		drawer: null,
		navbar: 236,
		toggleDrawer: false,
		activeMenu: '',
		arrMenu: [
			{
				title: 'Dashboard',
				path: '/',
				icon: 'mdi-home',
				children: [],
			},
			{
				title: 'Jaringan',
				path: '',
				icon: 'mdi-account-group',
				children: [
					{
						title: 'Genealogy',
						path: '/genealogy',
					},
					{
						title: 'Calon Prospek Mitra',
						path: '/prospek-membership',
					},
					{
						title: 'Prospek Mitra',
						path: '/prospek-mitra',
					},
					{
						title: 'Sponsor Pribadi',
						path: '/sponsor-pribadi',
					},
					{
						title: 'Downline',
						path: '/downline',
					},
					{
						title: 'Pertumbuhan Jaringan',
						path: '/pertumbuhan-jaringan',
					},
					{
						title: 'Registrasi',
						path: '/registrasi-mitra',
					},
					{
						title: 'Registrasi Pra-Mitra',
						path: '/registrasi-pramitra',
					},
					{
						title: 'Aktivasi Mitra',
						path: '/aktivasi-mitra',
					},
				],
			},
			{
				title: 'Komisi',
				path: '',
				icon: 'mdi-database',
				children: [
					{
						title: 'Summary Komisi',
						path: '/summary-komisi',
					},
					{
						title: 'Histori Komisi',
						path: '/histori-komisi',
					},
					{
						title: 'Histori Transfer',
						path: '/histori-transfer',
					},
				],
			},
			{
				title: 'Stock Serial',
				path: '/stock-serial',
				icon: 'mdi-card-bulleted',
				children: [],
			},
			{
				title: 'List Stockist',
				path: '/list-stockist',
				icon: 'mdi-account-details',
				children: [],
			},
			{
				title: 'Repeat Order',
				path: '/',
				icon: 'mdi-credit-card-sync',
				children: [
					{
						title: 'Tambah RO',
						path: '/tambah-ro',
					},
					{
						title: 'Histori RO',
						path: '/histori-ro',
					},
					{
						title: 'Omset Grup',
						path: '/omset-grup',
					},
				],
			},
			{
				title: 'Transaksi Produk',
				path: '',
				icon: 'mdi-cart',
				children: [
					{
						title: 'Belanja Produk',
						path: '/belanja-produk',
					},
					{
						title: 'Lap. Pembelian Produk',
						path: '/lap-pembelian-produk',
					},
					{
						title: 'Mutasi Saldo Belanja',
						path: '/mutasi-saldo-belanja',
					},
				]
			},
			{
				title: 'Transaksi Serial',
				path: '',
				icon: 'mdi-credit-card-plus',
				children: [
					{
						title: 'Penukaran Serial',
						path: '/penukaran-serial',
					},
					{
						title: 'Lap. Transaksi Serial',
						path: '/lap-transaksi-serial',
					},
				]
			},
			{
				title: 'Saldo E-Wallet',
				path: '/',
				icon: 'mdi-wallet',
				children: [
					{
						title: 'Transfer Saldo',
						path: '/transfer-saldo',
					},
					{
						title: 'Histori Transfer Saldo',
						path: '/histori-transfer-saldo',
					},
				],
			},
			{
				title: 'Reward',
				path: '/',
				icon: 'mdi-medal',
				children: [
					{
						title: 'List Reward',
						path: '/list-reward',
					},
					{
						title: 'Reward Saya',
						path: '/reward-saya',
					},
				],
			},
			{
				title: 'Pesan',
				path: '/',
				icon: 'mdi-email',
				children: [
					{
						title: 'Buat Pesan',
						path: '/buat-pesan',
					},
					{
						title: 'Inbox',
						path: '/inbox',
					},
					{
						title: 'Pesan Terkirim',
						path: '/pesan-terkirim',
					},
					{
						title: 'Arsip',
						path: '/arsip',
					},
				],
			},
			{
				title: 'Berita & Pengumuman',
				path: '/',
				icon: 'mdi-newspaper-variant-multiple-outline',
				children: [
					{
						title: 'Berita',
						path: '/berita',
					},
					{
						title: 'Pengumuman',
						path: '/pengumuman',
					},
				],
			},
			{
				title: 'Testimoni',
				path: '/testimoni',
				icon: 'mdi-format-float-left',
				children: [],
			},
		],
	}),
	methods: {
		...mapMutations(['hideSnackbar', 'hideAlert']),

		setActiveMenu(child) {
			if (child) {
				// eslint-disable-next-line no-unused-vars
				this.arrMenu.forEach((menu, index) => {
					if (menu.children.length > 0) {
						// eslint-disable-next-line no-unused-vars
						menu.children.forEach((childMenu, idc) => {
							if (childMenu.path === child) this.activeMenu = menu.title
						})
					}
				})
			} else {
				this.activeMenu = ''
			}
		},

		clickDrawer() {
			if (window.matchMedia('(min-width: 1264px)').matches) {
				if (this.navbar == 236) {
					this.navbar = 60
				} else {
					this.navbar = 236
				}
			} else {
				this.drawer = !this.drawer
			}
			this.toggleDrawer = false
		},

		showDrawer() {
			if (this.navbar == 60) {
				this.navbar = 236
				this.toggleDrawer = true
			}
		},

		hideDrawer() {
			if (this.toggleDrawer == true) {
				this.navbar = 60
			}
		},

		filterUnread(inbox) {
			const unread = inbox.filter(x => x.message_status == 0)
			return unread.length
		}
	},
	created() {
		const authData = localStorage.getItem('mlmcore-vo-auth-data');
		const data = JSON.parse(authData);

		// if isStockist
		if (data.bin_network_is_stockist === "1" || data.bin_network_is_stockist === 1) {
			let stockistMenu = {
				title: 'Stockist Area',
				path: '/',
				icon: 'mdi-storefront',
				children: [
					{
						title: 'Stock Produk',
						path: '/stock-produk',
					},
					{
						title: 'Belanja Produk',
						path: '/belanja-produk-stockist',
					},
					{
						title: 'Lap. Belanja Produk',
						path: '/lap-belanja-produk-stockist',
					},
					{
						title: 'Approval Transaksi',
						path: '/approval-transaksi',
					},
				],
			}

			this.arrMenu.splice(3, 0, stockistMenu) 
		}

		// if Upgradable
		if (data.network_type !== "diamond") {
			let upgradeMenu = {
				title: 'Upgrade Kemitraan',
				path: '/upgrade-kemitraan',
				icon: 'mdi-shield-account-outline',
				children: [],
			}

			this.arrMenu.splice(5, 0, upgradeMenu) 
		}

		// if Pramitra
		if (data.bin_network_id === "0" || data.bin_network_id === 0) {
			this.arrMenu = [
				{
					title: 'Dashboard',
					path: '/',
					icon: 'mdi-home',
					children: [],
				},
				{
					title: 'Aktivasi',
					path: '/aktivasi',
					icon: 'mdi-account-reactivate-outline',
					children: [],
				},
				{
					title: 'List Stockist',
					path: '/list-stockist',
					icon: 'mdi-account-details',
					children: [],
				},
				{
					title: 'Transaksi Produk',
					path: '',
					icon: 'mdi-cart',
					children: [
						{
							title: 'Beli Produk',
							path: '/product-purchase',
						},
						{
							title: 'List Transaksi Produk',
							path: '/product-purchase-report',
						},
						{
							title: 'Mutasi Saldo',
							path: '/balance-mutation',
						},
					]
				},
				{
					title: 'Transaksi Serial',
					path: '',
					icon: 'mdi-credit-card-plus',
					children: [
						{
							title: 'Penukaran Serial',
							path: '/penukaran-serial',
						},
						{
							title: 'Lap. Transaksi Serial',
							path: '/lap-transaksi-serial',
						},
					]
				},
				{
					title: 'Inbox',
					path: '/inbox',
					icon: 'mdi-email',

					children: [],
				}
			]
		}

		this.setActiveMenu(this.$route.path)
	}
};
</script>

<style lang="scss" scoped>
	.cus-m-navbar {
		padding: 0 5px;
	}
</style>